import { CfgMtrlApplicationSource } from "./CfgMtrlApplicationSource.js";
import { CfgMtrlSourceBuffer, CfgMtrlSourceUrl } from "./CfgMtrlSource.js";
export class CfgMtrlApplication {
    constructor(_source, _areaTags, _mtrl, _previewUrl) {
        this._source = _source;
        this._areaTags = _areaTags;
        this._mtrl = _mtrl;
        this._previewUrl = _previewUrl;
    }
    static fromUrlForDebug(areaTags, url) {
        return this.fromMtrlSourceForDebug(areaTags, new CfgMtrlSourceUrl(url, "debug"));
    }
    static fromBufferForDebug(areaTags, fileName, buffer) {
        return this.fromMtrlSourceForDebug(areaTags, new CfgMtrlSourceBuffer(fileName, buffer));
    }
    static fromMtrlSourceForDebug(areaTags, mtrlSource) {
        const ts = areaTags.filter((t) => t.trim() !== "");
        if (ts.length === 0) {
            throw Error("No tags");
        }
        return new this(CfgMtrlApplicationSource.Debug, areaTags, mtrlSource, undefined);
    }
    static fromMtrlLikeApplication(source, application) {
        const materialUrl = application.material;
        const previewUrl = application.preview;
        const url = materialUrl || previewUrl;
        const urlIsFromProperty = materialUrl ? "material" : "preview";
        const mtrl = url ? new CfgMtrlSourceUrl(url, urlIsFromProperty) : undefined;
        return new this(source, application.areas, mtrl, previewUrl);
    }
    get source() {
        return this._source;
    }
    get areaTags() {
        return this._areaTags;
    }
    get mtrl() {
        return this._mtrl;
    }
    get previewUrl() {
        return this._previewUrl;
    }
}
